<template>
<div>
      <h1>暂时/好像/应该/可能/大概/差不多/用不着</h1>
</div>

</template>

<script>
export default {

}
</script>

<style>

</style>